var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts-container"},[_c('div',{staticClass:"chart"},[_c('div',{ref:"chart",staticClass:"riskChart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }